<!-- full report view -->
<ng-container *ngIf="type !== 'card'">
	<div class="report-container bg-white" [ngClass]="{'main-content p-4': type !== 'dash'}">
		<div class="report-header" *ngIf="type !== 'dash'">
			<h2>New Items Report</h2>
		</div>
		<div class="filter-bar m-0 p-0 row gap-0">
			<div class="row col-6 m-0 p-0 justify-content-start">
				<mat-form-field appearance="outline">
					<mat-label>Brand</mat-label>
					<mat-select [formControl]="brands" multiple appSelectAll>
						<mat-option [value]="brand.manufacturer_id" *ngFor="let brand of all_brands">
							{{ brand.name.toUpperCase() }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Category</mat-label>
					<mat-select [formControl]="categories" multiple appSelectAll>
						<mat-option [value]="cat.categoryid" *ngFor="let cat of all_categories">
							{{ cat.categorydescription.toUpperCase() }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline" class="date-range-field">
					<mat-label>Date Range</mat-label>
					<mat-date-range-input [rangePicker]="picker" (keyup.enter)="runReport()">
						<input matStartDate [formControl]="fromdateCtrl" placeholder="Start date">
						<input matEndDate [formControl]="todateCtrl" placeholder="End date">
					</mat-date-range-input>
					<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
					<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-date-range-picker #picker></mat-date-range-picker>
				</mat-form-field>
				<button mat-raised-button color="primary" class="ml-1" (click)="runReport()" [disabled]="running">
					<span *ngIf="!running">Run</span>
					<svg *ngIf="running" class="spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
				</button>
			</div>
			<div class="row col-6 m-0 p-0 justify-content-end" *ngIf="reportdata && reportdata.items.length">
				<div class="table-actions float-right">
					<button mat-stroked-button (click)="export('xlsx')" [disabled]="exportingxlsx">
						<ng-container *ngIf="exportingxlsx">
							<svg class="spinner" width="14px" height="14px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
						</ng-container>
						<ng-container *ngIf="!exportingxlsx">
							<mat-icon>table_view</mat-icon>
						</ng-container>
						Export Excel
					</button>
					<button mat-stroked-button (click)="export('pdf')" [disabled]="exportingpdf">
						<ng-container *ngIf="!exportingpdf">
							<mat-icon>picture_as_pdf</mat-icon>
						</ng-container>
						<ng-container *ngIf="exportingpdf">
							<svg class="spinner" width="14px" height="14px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
						</ng-container>
						Export PDF
					</button>
					<div class="changelog-record-count compact-pager">
						<mat-paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
					</div>
				</div>
			</div>
		</div>

		<ng-container *ngIf="reportdata && reportdata.items?.length > 0; else noData">
			<div class="table-container">
				<table class="table-striped">
					<thead>
						<tr>
							<th>Item</th>
							<th>Manufacturer</th>
							<th>Product Line</th>
							<th>Category</th>
							<th>Created</th>
							<th class="text-center iq-col-loc" *ngFor="let loc of locations" [matTooltip]="loc.locationname">{{ loc.loccode }}</th>
							<th class="text-center iq-col-total">Total</th>
							<th class="text-center">Web Enabled</th>
							<th class="text-center">Discontinued</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of dataObs | async">
							<td class="item-cell">
								<span class="item-stockid-row">
									<span class="item-stockid">{{ row.stockid.toUpperCase() }}</span>
									<button mat-icon-button class="copy-btn" (click)="copyToClipboard(row.stockid, $event)" [matTooltip]="copiedStockId === row.stockid ? 'Copied!' : 'Copy'">
										<mat-icon>{{ copiedStockId === row.stockid ? 'check' : 'content_copy'}}</mat-icon>
									</button>
								</span>
								<a class="item-desc" [routerLink]="['/inventory/view', row.stockid]">{{ row.description}}</a>
							</td>
							<td class="col-truncate">{{ row.name.toUpperCase() }}</td>
							<td class="col-truncate">{{ row.line_description }}</td>
							<td class="col-truncate">{{ row.categorydescription }}</td>
							<td class="text-nowrap">{{ row.date_created | date: 'short' }}</td>
							<td class="text-center iq-col-qty" *ngFor="let loc of locations; let i = index"
								[ngClass]="{'col-border-l': i === 0}">
								<span [ngClass]="getQohClass(row.qtyMap[loc.loccode] ?? 0)">{{ (row.qtyMap[loc.loccode]?? 0) | number:'1.0-0' }}</span>
							</td>
							<td class="text-center iq-col-qty col-border-r">
								<span [ngClass]="getQohClass(row.totalQty)">{{ row.totalQty | number:'1.0-0' }}</span>
							</td>
							<td class="text-center">
								<mat-icon class="status-icon cursor" [matTooltip]="(!pos && !salesman) ? (row.enabled ? 'disable?' : 'enable?') : ''" [class.status-yes]="row.enabled == 1" [class.status-no]="row.enabled != 1" (click)="updateItemDiscontinuedWeb(row, 'enabled', row.enabled == 1 ? 'false' : 'true')">
									{{ row.enabled == 1 ? 'check_circle' : 'cancel' }}
								</mat-icon>
							</td>
							<td class="text-center">
								<mat-icon class="status-icon cursor" [matTooltip]="(!pos && !salesman) ? (row.discontinued ? 'set active?' : 'discontinue?') : ''" [class.status-yes]="row.discontinued == 1" [class.status-no]="row.discontinued != 1" (click)="updateItemDiscontinuedWeb(row, 'discontinued', row.discontinued == 1 ? 'false' : 'true')">
									{{ row.discontinued == 1 ? 'check_circle' : 'cancel' }}
								</mat-icon>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</ng-container>

		<ng-template #noData>
			<div class="no-data" *ngIf="reportdata || (!reportdata && running)">
				<mat-icon>inbox</mat-icon>
				<ng-container *ngIf="running">
					<p>Report is running...</p>
				</ng-container>
				<ng-container *ngIf="!running">
					<p>No items found for the selected filters.</p>
				</ng-container>
			</div>
		</ng-template>
	</div>
</ng-container>